import { SortedTimeframeCollection } from '../../shared/timeframe';
import { Playability } from './Playability';
const DEFAULT_TRM_DURATION = 5;
/**
 * Whether this recording is live
 */
export function isLive({ segments }) {
    return segments.some(s => s.playability === Playability.Live);
}
/**
 * Whether this recording is on the record
 * @param onTheRecordTimeframes the recording's on the record timeframes
 * @param currentSecondOfTheDay the LocalDateTime second of the day in timezone of the court system
 */
export function isOnTheRecord(onTheRecordTimeframes, currentSecondOfTheDay) {
    // SortedTimeframeCollection mutates its input array, so we need to make a shallow copy
    return new SortedTimeframeCollection([...onTheRecordTimeframes]).hasThisSecondOfTheDay(Math.ceil(currentSecondOfTheDay));
}
/**
 * Get start date and time based on recording segments
 */
export function getRecordingStart(recordingSegments) {
    var _a;
    if (recordingSegments.length === 0) {
        return undefined;
    }
    const segmentsWithTimecode = recordingSegments.filter(s => !!s.timecode);
    const firstSegment = segmentsWithTimecode.length
        ? segmentsWithTimecode.sort(sortSegments)[0]
        : recordingSegments.sort(sortSegments)[0];
    return ((_a = firstSegment.timecode) === null || _a === void 0 ? void 0 : _a.start) || firstSegment.startDateTime;
}
/**
 * Get end date and time based on recording segments
 */
export function getRecordingEnd(recordingSegments) {
    var _a;
    if (recordingSegments.length === 0) {
        return undefined;
    }
    const segmentsWithTimecode = recordingSegments.filter(s => !!s.timecode);
    const lastSegment = segmentsWithTimecode.length
        ? segmentsWithTimecode.sort(sortSegments)[segmentsWithTimecode.length - 1]
        : recordingSegments.sort(sortSegments)[recordingSegments.length - 1];
    return ((_a = lastSegment.timecode) === null || _a === void 0 ? void 0 : _a.end) || lastSegment.startDateTime.plusMinutes(DEFAULT_TRM_DURATION);
}
function sortSegments(a, b) {
    return a.startDateTime.compareTo(b.startDateTime);
}
